<template>
  <div class="container">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>sports_soccer</md-icon>
        </div>
        <h4 class="title">{{ $t("teams.create.title") }}</h4>
      </md-card-header>

      <md-card-content>
        <!-- TODO: validacion -->

        <!-- Nombre -->
        <md-field
          :class="{
            'md-error': $v.teamModel.name.$error && $v.teamModel.name.$invalid,
            'md-valid': !$v.teamModel.name.$error && !$v.teamModel.name.$invalid
          }"
        >
          <label>{{ $t("teams.create.name") }}</label>
          <md-input v-model.trim="$v.teamModel.name.$model"></md-input>
          <slide-y-down-transition>
            <md-icon
              class="error"
              v-show="$v.teamModel.name.$error && $v.teamModel.name.$invalid"
            >
              close
            </md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon
              class="success"
              v-show="!$v.teamModel.name.$error && !$v.teamModel.name.$invalid"
            >
              done
            </md-icon>
          </slide-y-down-transition>
        </md-field>

        <!-- Escudo -->
        <md-field
          :class="{
            'md-error':
              $v.teamModel.shield.$error && $v.teamModel.shield.$invalid,
            'md-valid':
              !$v.teamModel.shield.$error && !$v.teamModel.shield.$invalid
          }"
        >
          <label>{{ $t("teams.create.shield") }}</label>
          <md-file accept="image/*" @md-change="shieldUpload" />
          <slide-y-down-transition>
            <md-icon
              class="error"
              v-show="
                $v.teamModel.shield.$error && $v.teamModel.shield.$invalid
              "
            >
              close
            </md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon
              class="success"
              v-show="
                !$v.teamModel.shield.$error && !$v.teamModel.shield.$invalid
              "
            >
              done
            </md-icon>
          </slide-y-down-transition>
        </md-field>
        <!-- Animación Goal -->
        <md-field
          :class="{
            'md-error': $v.teamModel.goalAnimation.$error && $v.teamModel.goalAnimation.$invalid,
            'md-valid': !$v.teamModel.goalAnimation.$error && !$v.teamModel.goalAnimation.$invalid
          }"
        >
          <label>{{ $t("teams.create.goalAnimation") }}</label>
          <md-file @md-change="goalUpload" />
          <slide-y-down-transition>
            <md-icon
              class="error"
              v-show="$v.teamModel.goalAnimation.$error && $v.teamModel.goalAnimation.$invalid"
            >
              close
            </md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon
              class="success"
              v-show="!$v.teamModel.goalAnimation.$error && !$v.teamModel.goalAnimation.$invalid"
            >
              done
            </md-icon>
          </slide-y-down-transition>
        </md-field>
        <md-button
          @click="createTeam"
          :disabled="loading"
          class="md-info"
          :class="{ disabled: loading }"
        >
          {{ $t("teams.create.create") }}
        </md-button>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import storage from "@/plugins/azure-storage";
import { required } from "vuelidate/lib/validators";
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      loading: false,
      teamModel: {
        name: "",
        shield: "",
        goalAnimation: ""
      }
    };
  },
  methods: {
    async shieldUpload(FileList) {
      const file = FileList[0];

      this.loading = true;
      const fileName = await storage.updateFile({
        file,
        container: process.env.VUE_APP_CDN_CONTAINER_SHIELDS
      });
      this.loading = false;
      this.teamModel.shield = fileName;

      this.$v.teamModel.shield.$touch();
      return;
    },
    async goalUpload(FileList) {
      const file = FileList[0];
      if (file.size > 1572864) {
        this.$notify({
          message: this.$t(`notifications.team.updateGoalSize`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'danger'
        })
        return;
      }
      console.log(file)
      this.loading = true;
      const fileName = await storage.updateFile({
        file,
        container: process.env.VUE_APP_CDN_CONTAINER_GOAL
      });
      this.loading = false;
      this.teamModel.goalAnimation = fileName;

      this.$v.teamModel.goalAnimation.$touch();
      return;
    },
    async createTeam() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        this.loading = true;
        await this.$store.dispatch("teamCreate", this.teamModel);
        this.loading = false;
        this.$notify({
          message: this.$t(`notifications.team.create`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
        this.$router.push("/list/teams");
        return;
      }
    }
  },
  validations: {
    teamModel: {
      name: {
        required
      },
      shield: {
        required
      },
      goalAnimation: {}
    }
  }
};
</script>
